import clearStoredSession from "@wine2trace/auth/clearStoredSession";
import { stopImpersonating } from "../context/impersonation/impersonationSlice";
import { resetActive as resetActiveWinery, empty as emptyWineriesList } from "../context/wineries/wineriesSlice";

// Pulizia dello stato Redux legato alla sessione, dopo quella della sessione
// (clearStoredSession). Condivisa da useLogout (logout volontario) e
// useEndSession (refresh rifiutato). Non fa chiamate di rete ne' navigazione.
// Azzera anche l'impersonazione (active + savedAdminAuth, quello che legge il
// banner): dopo un nuovo login senza reload non deve poter ripristinare un
// vecchio savedAdminAuth.
// Solo wineries: è l'unico slice che sopravvive come header stantio
// (wineryid/clientname) sulla prima richiesta del prossimo login.
// Svuotare qui anche operations/tanks/analysis/ecc. risveglierebbe i
// guard "if lista vuota, ricarica" delle pagine ancora montate un
// istante prima che navigate() le smonti, causando una raffica di
// richieste 401/428 e un login percepito come lento.
export const clearSessionState = (dispatch) => {
  dispatch(stopImpersonating());
  dispatch(emptyWineriesList());
  dispatch(resetActiveWinery());
};

const clearLocalSession = ({ setAuth, dispatch }) => {
  clearStoredSession(setAuth);
  clearSessionState(dispatch);
};

export default clearLocalSession;
